import { Component, ElementRef, Input, OnInit, signal, ViewChild, WritableSignal } from '@angular/core';
import { WordData } from '@shared/models/step.model';
import * as cloud from 'd3-cloud';
import { PlSlicePipe } from '@shared/pipes/plSlice/plSlice.pipe';

// I redefined this instead of using the definition from angular-d3-cloud because the input ("data") of angular-d3-cloud
// is supposed to be "AngularD3Word" but it's defined in the component library as cloud.Word[] which causes issue, no clue why he has done that
export interface AngularD3Word extends cloud.Word {
  value?: number;
}

@Component({
  selector: 'pl-word-cloud',
  templateUrl: './wordCloud.component.html',
})
export class WordCloudComponent implements OnInit {
  @Input() public title: string = '';
  @Input({ required: true }) public wordData: WordData[] = [];

  public data: WritableSignal<AngularD3Word[]> = signal([]);
  public fontSizeMapper: (datum: AngularD3Word, index: number) => number = (word: AngularD3Word): number =>
    word.value ? word.value * 3.3 : 1;
  public rotateFn: (datum: AngularD3Word, index: number) => number = (): number => 0;
  public isWordCloudEmpty: WritableSignal<boolean> = signal(false);
  public widthWordCloud: WritableSignal<number | undefined> = signal(undefined);

  // Without this, it's possible to have very have value for power that breaks wordCloud
  private readonly MAX_VALUE_FOR_WORD: number = 25;

  @ViewChild('wordCloudContainer', { static: true }) public wordCloudContainer!: ElementRef;

  constructor(private plSlicePipe: PlSlicePipe) {}

  public ngOnInit(): void {
    const wordCloudContainerWidth: number = this.wordCloudContainer.nativeElement.clientWidth;
    this.widthWordCloud.set(wordCloudContainerWidth);
    this.isWordCloudEmpty.set(this.wordData.length === 0);

    console.log('TONIO WordCloudComponent ngOnInit wordsConverted=', this.convertWordDataAndAdjustPower(this.wordData));

    this.data.set(this.convertWordDataAndAdjustPower(this.wordData));
  }

  private convertWordDataAndAdjustPower(words: WordData[]): AngularD3Word[] {
    if (words.length === 0) {
      return [];
    }

    const wordWithHighestPower: WordData = words.sort((a: WordData, b: WordData): number => {
      return b.power - a.power;
    })[0];

    const numberOfWordsMoreThanHalfMaxPower: number = words.filter((word: WordData): boolean => {
      return word.power > wordWithHighestPower.power / 2;
    }).length;

    let coefficient: number = 1;
    if (wordWithHighestPower.power !== 0) {
      if (numberOfWordsMoreThanHalfMaxPower > words.length / 2) {
        // Too many words with high value, they won't all fit on the screen
        coefficient = this.MAX_VALUE_FOR_WORD / wordWithHighestPower.power / 2.5;
      } else {
        coefficient = this.MAX_VALUE_FOR_WORD / wordWithHighestPower.power;
      }
    }

    return words.map((word: WordData): AngularD3Word => {
      return {
        text: this.plSlicePipe.transform(word.text, 30),
        value: word.power * coefficient,
      };
    });
  }
}
